'use strict';

var _ = require('lodash');
var UserSearchService = function UserSearchService(ConfigurationService) {
  function getUserDisplayNameFromId(userId) {
    var userList = ConfigurationService.getAllUsers();
    return _.find(userList, {
      userId: userId
    });
  }
  function getUserIdFromDisplayName(displayName) {
    var userList = ConfigurationService.getAllUsers();
    return _.chain(userList).filter(function (user) {
      return (user.getDisplayName() || '').toLowerCase() === (displayName || '').toLowerCase();
    }).first().value();
  }
  return {
    getUserDisplayNameFromId: getUserDisplayNameFromId,
    getUserIdFromDisplayName: getUserIdFromDisplayName
  };
};
UserSearchService.$inject = ['ConfigurationService'];
module.exports = UserSearchService;